var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.87154 0.305082C2.509 1.90358 -0.862436 9.07408 2.01299 14.892C5.90279 22.7626 16.7182 22.7626 20.608 14.892C24.4021 7.21562 17.1656 -1.77824 8.87154 0.305082ZM12.5284 3.42799C15.5169 4.55466 16.2505 7.7696 14.0591 10.1358C12.7868 11.5094 12.3503 12.2446 12.3503 13.0135C12.3503 13.4669 12.1881 13.5506 11.3105 13.5506C9.58383 13.5506 9.92932 11.7818 12.1049 9.48144C13.6132 7.88684 13.7887 6.90653 12.752 5.87006C11.6718 4.78967 10.0978 5.10656 9.34857 6.55532C8.76886 7.67653 7.57797 7.56163 7.46229 6.37309C7.26446 4.34097 10.2878 2.58338 12.5284 3.42799ZM12.2204 16.6701C12.2204 17.8361 10.4765 18.116 10.3151 16.9761C10.168 15.937 10.4513 15.5897 11.3737 15.6786C12.1525 15.7538 12.2204 15.8333 12.2204 16.6701Z",
    fill: "#48C0B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help_icon.1c420f4061ba13fc9aad173f87794366.svg";
export { ForwardRef as ReactComponent };